import {
    Dropdown,
    Modal
} from "bootstrap";

if(document.querySelector('.modal-notice')) {
    const closedModalAlready = sessionStorage.getItem('noticeModalClosed') ?? false;

    const modalNotice = document.querySelector('.modal-notice');

    const modal = Modal.getOrCreateInstance(modalNotice);
    if(closedModalAlready === false) {
        modal.show();
    }

    modalNotice.addEventListener('hidden.bs.modal', () => {
        sessionStorage.setItem('noticeModalClosed', true);
    });
}